module.exports = __webpack_public_path__ + "static/media/img-119.5ad6afff.jpg";